;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreTableColumnRowDate', tableColumnRowDate)

  /* @ngInject */
  function tableColumnRowDate () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        simplified: '<',
        showFromNowLabel: '<'
      },
      controller: 'TableColumnRowDateController',
      templateUrl: '/core/directives/table-columns/table-column-row-date/table-column-row-date-directive.html?$$REVISION$$'
    }
  }
})()
